import styled from 'styled-components';
import theme from 'styled-theming';
import { prefix } from '../../tools/settings';
import Subheading from '../Subheading';
import Button from '../Button';
import Link from '../Link';
import Caption from '../Caption';
var EmptyState = styled.div.withConfig({
  displayName: "EmptyStatestyles__EmptyState",
  componentId: "sc-1sep95i-0"
})(["background:var(--dentsu-color-white);display:flex;width:100%;"]);
var Inner = styled.div.withConfig({
  displayName: "EmptyStatestyles__Inner",
  componentId: "sc-1sep95i-1"
})(["display:flex;flex-direction:column;align-items:center;margin:auto;text-align:center;padding-top:", ";padding-bottom:", ";padding-left:", ";padding-right:", ";@media (min-width:1024px){flex-direction:", ";text-align:", ";}"], function (props) {
  return props.paddingTop;
}, function (props) {
  return props.paddingBottom;
}, function (props) {
  return props.paddingLeft;
}, function (props) {
  return props.paddingRight;
}, theme('layout', {
  horizontal: 'row',
  vertical: 'column'
}), theme('layout', {
  horizontal: 'left',
  vertical: 'center'
}));
var Image = styled.div.withConfig({
  displayName: "EmptyStatestyles__Image",
  componentId: "sc-1sep95i-2"
})(["margin-bottom:", ";width:", ";height:", ";display:flex;flex:0 0 auto;@media (min-width:1024px){margin-bottom:", ";margin-right:", ";}img{width:100%;height:100%;object-fit:contain;margin:auto;}"], theme('size', {
  small: 'var(--dentsu-spacing-28)',
  medium: 'var(--dentsu-spacing-32)',
  large: 'var(--dentsu-spacing-40)'
}), theme('size', {
  small: '160px',
  medium: '240px',
  large: '360px'
}), theme('size', {
  small: '160px',
  medium: '240px',
  large: '360px'
}), theme('layout', {
  horizontal: 0,
  vertical: theme('size', {
    small: 'var(--dentsu-spacing-28)',
    medium: 'var(--dentsu-spacing-32)',
    large: 'var(--dentsu-spacing-40)'
  })
}), theme('layout', {
  horizontal: theme('size', {
    small: 'var(--dentsu-spacing-28)',
    medium: 'var(--dentsu-spacing-32)',
    large: 'var(--dentsu-spacing-40)'
  }),
  vertical: 0
}));
var Content = styled.div.withConfig({
  displayName: "EmptyStatestyles__Content",
  componentId: "sc-1sep95i-3"
})(["max-width:450px;flex:1 1 auto;"]);
var Metadata = styled.p.withConfig({
  displayName: "EmptyStatestyles__Metadata",
  componentId: "sc-1sep95i-4"
})(["color:var(--dentsu-color-n700);font-weight:var(--dentsu-font-weight-regular);font-size:var(--dentsu-font-size-12);line-height:var(--dentsu-leading-normal);text-align:center;margin:0;padding:0;@media (min-width:1024px){text-align:", ";}"], theme('layout', {
  horizontal: 'left',
  vertical: 'center'
}));
var Heading = styled(Subheading).withConfig({
  displayName: "EmptyStatestyles__Heading",
  componentId: "sc-1sep95i-5"
})(["font-weight:var(--dentsu-font-weight-semibold);font-size:", ";letter-spacing:", ";margin-top:", ";margin-bottom:", ";line-height:", ";"], theme('size', {
  small: 'var(--dentsu-font-size-16)',
  medium: 'var(--dentsu-font-size-24)',
  large: 'var(--dentsu-font-size-24)'
}), theme('size', {
  small: 'var(--dentsu-tracking-normal)',
  medium: 'var(--dentsu-tracking-normal)',
  large: 'var(--dentsu-tracking-tight)'
}), theme('size', {
  small: 'var(--dentsu-spacing-4)',
  medium: 'var(--dentsu-spacing-8)',
  large: 'var(--dentsu-spacing-8)'
}), theme('size', {
  small: 'var(--dentsu-spacing-8)',
  medium: 'var(--dentsu-spacing-12)',
  large: 'var(--dentsu-spacing-12)'
}), theme('size', {
  small: 'var(--dentsu-leading-normal)',
  medium: 'var(--dentsu-leading-tight)',
  large: 'var(--dentsu-leading-tight)'
}));
var Body = styled.div.withConfig({
  displayName: "EmptyStatestyles__Body",
  componentId: "sc-1sep95i-6"
})(["color:var(--dentsu-color-n700);font-weight:var(--dentsu-font-weight-regular);font-size:var(--dentsu-font-size-14);line-height:var(--dentsu-leading-normal);p{margin-top:", ";color:var(--dentsu-color-n700);font-weight:var(--dentsu-font-weight-regular);font-size:var(--dentsu-font-size-14);line-height:var(--dentsu-leading-normal);}"], theme('size', {
  small: 'var(--dentsu-spacing-8)',
  medium: 'var(--dentsu-spacing-12)',
  large: 'var(--dentsu-spacing-12)'
}));
var Actions = styled.div.withConfig({
  displayName: "EmptyStatestyles__Actions",
  componentId: "sc-1sep95i-7"
})(["margin-top:", ";display:flex;flex-direction:column;align-items:center;justify-content:center;@media (min-width:1024px){justify-content:flex-start;flex-direction:", ";}"], theme('size', {
  small: 'var(--dentsu-spacing-20)',
  medium: 'var(--dentsu-spacing-24)',
  large: 'var(--dentsu-spacing-24)'
}), theme('layout', {
  horizontal: 'row',
  vertical: 'column'
}));
var PrimaryAction = styled(Button).withConfig({
  displayName: "EmptyStatestyles__PrimaryAction",
  componentId: "sc-1sep95i-8"
})(["margin-bottom:var(--dentsu-spacing-20);@media (min-width:1024px){margin-right:var(--dentsu-spacing-16);margin-bottom:", ";}"], theme('layout', {
  horizontal: 0,
  vertical: 'var(--dentsu-spacing-20)'
}));
var SecondaryAction = styled(Link).withConfig({
  displayName: "EmptyStatestyles__SecondaryAction",
  componentId: "sc-1sep95i-9"
})(["margin-bottom:var(--dentsu-spacing-20);@media (min-width:1024px){margin-bottom:0;margin-right:var(--dentsu-spacing-16);}"]);
var FooterContent = styled(Caption).withConfig({
  displayName: "EmptyStatestyles__FooterContent",
  componentId: "sc-1sep95i-10"
})(["color:var(--dentsu-color-n700);"]);
var Footer = styled.div.withConfig({
  displayName: "EmptyStatestyles__Footer",
  componentId: "sc-1sep95i-11"
})(["color:var(--dentsu-color-n700);margin-top:var(--dentsu-spacing-20);.", "-link{color:inherit;font-size:inherit;.", "-link__label{text-decoration:underline;&:hover::before{width:0;}}}"], prefix, prefix);
export var Styled = {
  Actions: Actions,
  Body: Body,
  Content: Content,
  EmptyState: EmptyState,
  Footer: Footer,
  FooterContent: FooterContent,
  Heading: Heading,
  Image: Image,
  Inner: Inner,
  Metadata: Metadata,
  PrimaryAction: PrimaryAction,
  SecondaryAction: SecondaryAction
};